import React, { useEffect, useState } from "react"
import { useStyles } from "./styles"
import { useSelector, useDispatch } from 'react-redux';
import { Text } from "../text";
import { hasUnsyncedChanges } from '@nozbe/watermelondb/sync'
import { useDatabase } from '@nozbe/watermelondb/react';
import { IconButton } from "../Button";
import { size } from "../../lib/lodash";

export const SyncControl = props => {
    const classes = useStyles();
    const dbstate = useSelector(s => s.db);
    const db = useDatabase();
    const dispatch = useDispatch();

    const [state, setState] = useState({
        hasChanges: false,
        hasTasks: false,
    })

    const checkForChanges = async () => {
        const [hasChanges, taskCount] = await Promise.all([
            hasUnsyncedChanges({ database: db }),
            db.get('task').query(),
        ]) 
        setState(s => ({ ...s, hasChanges, hasTasks: !!size(taskCount) }))
    }

    const sync = async () => {
        try {
            dispatch({ type: 'SET_DB', data: { syncing: true } })
            await window.SYNC();
        } catch (err) {
            console.error(err);
        } finally {
            dispatch({ type: 'SET_DB', data: { syncing: false } })
        }
    }

    const clearAll = () => {
        const conf = window.confirm('This will delete all data stored in WatermelonDB. Do you wish to continue?')

        if (conf) {
            window.CLEAR();
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            checkForChanges();
        }, 5000);
        
        return () => {
            clearInterval(interval)
        }
    }, []);

    return (
        <div className={classes.container}>
            {<Text className={classes.text}>{dbstate.syncing ? 'SYNCING' : state.hasChanges ? 'HAS CHANGES' : 'SYNC'}</Text>}
            <IconButton loading={dbstate.syncing} className={classes.syncBtn} onClick={sync} size="small" variant="default" icon="refresh" />
            {!!state.hasTasks && !dbstate.syncing && <IconButton loading={dbstate.syncing} className={classes.syncBtn} onClick={clearAll} size="small" variant="default" icon="delete" />}
        </div>
    )
}